/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GetEmployers2Params,
  GetEmployersParams1,
  GetReferralToolkitFileParams,
  MicrosoftAspNetCoreMvcProblemDetails,
  ModelsEmployer,
  RequestCreateHumanResourcesUserRequest,
  RequestEmployerSsoRequest,
  RequestEmployersAddEmployerRequest,
  ResponseEmployerResponse,
  ResponseEmployerResponsePaginated,
  ResponseEmployersEmployerReferralToolkitResponse,
  ResponseEmployersEmployerSsoResponse,
  ResponseEmployersHrUserResponse,
  UploadReferralToolkitPayload,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Employers<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Employers
   * @name AddEmployer
   * @summary Adds an employer (Auth policies: CustomerSuccessPolicy)
   * @request POST:/api/v1/employers
   * @secure
   * @response `201` `ResponseEmployerResponse` Created
   * @response `400` `MicrosoftAspNetCoreMvcProblemDetails` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  addEmployer = (
    data: RequestEmployersAddEmployerRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      ResponseEmployerResponse,
      MicrosoftAspNetCoreMvcProblemDetails | void
    >({
      path: `/api/v1/employers`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmployerHrUsers
   * @name CreateHumanResourcesUser
   * @summary Add a human resources user (Auth policies: CustomerSuccessPolicy)
   * @request POST:/api/v1/employers/{employerId}/hr-users
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  createHumanResourcesUser = (
    employerId: string,
    data: RequestCreateHumanResourcesUserRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/employers/${employerId}/hr-users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EmployerHrUsers
   * @name DeleteHumanResourcesUser
   * @summary  (Auth policies: CustomerSuccessPolicy)
   * @request DELETE:/api/v1/employers/{employerId}/hr-users/{hrUserId}
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  deleteHumanResourcesUser = (
    employerId: string,
    hrUserId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/employers/${employerId}/hr-users/${hrUserId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Employers
   * @name GetEmployerById
   * @summary Gets an employer by Id (Auth policies: CustomerSuccessPolicy)
   * @request GET:/api/v1/employers/{employerId}
   * @secure
   * @response `200` `ResponseEmployerResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getEmployerById = (employerId: string, params: RequestParams = {}) =>
    this.http.request<ResponseEmployerResponse, void>({
      path: `/api/v1/employers/${employerId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description By default, only active employers are returned. Use activeOnly=false to include inactive employers.
   *
   * @tags Employers
   * @name GetEmployers
   * @summary Retrieves a list of employers registered with OpenUp
   * @request GET:/api/v1/employers
   * @secure
   * @response `200` `(ModelsEmployer)[]` OK
   */
  getEmployers = (query: GetEmployersParams1, params: RequestParams = {}) =>
    this.http.request<ModelsEmployer[], any>({
      path: `/api/v1/employers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Employers
   * @name GetEmployers2
   * @summary Gets a paged list of employers OpenUp has been offered to (Auth policies: CustomerSuccessPolicy)
   * @request GET:/api/v1/employers/paged
   * @originalName getEmployers
   * @duplicate
   * @secure
   * @response `200` `ResponseEmployerResponsePaginated` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getEmployers2 = (query: GetEmployers2Params, params: RequestParams = {}) =>
    this.http.request<ResponseEmployerResponsePaginated, void>({
      path: `/api/v1/employers/paged`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Employers
   * @name GetEmployerSso
   * @request POST:/api/v1/employers/sso
   * @secure
   * @response `200` `ResponseEmployersEmployerSsoResponse` OK
   */
  getEmployerSso = (
    data: RequestEmployerSsoRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseEmployersEmployerSsoResponse, any>({
      path: `/api/v1/employers/sso`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Employers
   * @name GetEmployerSsoProviders
   * @request GET:/api/v1/employers/sso/{employerId}
   * @secure
   * @response `200` `(string)[]` OK
   */
  getEmployerSsoProviders = (employerId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/api/v1/employers/sso/${employerId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Employers
   * @name GetEmployerSsoProvidersBySlug
   * @request GET:/api/v1/employers/sso/by-slug/{slug}
   * @secure
   * @response `200` `(string)[]` OK
   */
  getEmployerSsoProvidersBySlug = (slug: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/api/v1/employers/sso/by-slug/${slug}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags EmployerHrUsers
   * @name GetHumanResourcesUsersFromCompany
   * @summary  (Auth policies: CustomerSuccessPolicy)
   * @request GET:/api/v1/employers/{employerId}/hr-users
   * @secure
   * @response `200` `(ResponseEmployersHrUserResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getHumanResourcesUsersFromCompany = (
    employerId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseEmployersHrUserResponse[], void>({
      path: `/api/v1/employers/${employerId}/hr-users`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Employers
   * @name GetReferralToolkit
   * @summary  (Auth policies: HostOrExpertOrCustomerSuccessPolicy)
   * @request GET:/api/v1/employers/{employerId}/referral-toolkit
   * @secure
   * @response `200` `ResponseEmployersEmployerReferralToolkitResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getReferralToolkit = (employerId: string, params: RequestParams = {}) =>
    this.http.request<ResponseEmployersEmployerReferralToolkitResponse, void>({
      path: `/api/v1/employers/${employerId}/referral-toolkit`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Employers
   * @name GetReferralToolkitFile
   * @summary  (Auth policies: HostOrExpertOrCustomerSuccessPolicy)
   * @request GET:/api/v1/employers/{employerId}/referral-toolkit/files
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getReferralToolkitFile = (
    { employerId, ...query }: GetReferralToolkitFileParams,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/employers/${employerId}/referral-toolkit/files`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Employers
   * @name RemoveReferralToolkit
   * @summary Removes the referral toolkit for an employer. Requires the Customer Success role. (Auth policies: CustomerSuccessPolicy)
   * @request DELETE:/api/v1/employers/{employerId}/referral-toolkit
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  removeReferralToolkit = (employerId: string, params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v1/employers/${employerId}/referral-toolkit`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Employers
   * @name UploadReferralToolkit
   * @summary Uploads or replaces the referral toolkit PDF for an employer. Requires the Customer Success role. (Auth policies: CustomerSuccessPolicy)
   * @request POST:/api/v1/employers/{employerId}/referral-toolkit
   * @secure
   * @response `200` `ResponseEmployersEmployerReferralToolkitResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  uploadReferralToolkit = (
    employerId: string,
    data: UploadReferralToolkitPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseEmployersEmployerReferralToolkitResponse, void>({
      path: `/api/v1/employers/${employerId}/referral-toolkit`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
}
